export default __webpack_public_path__ + "static/img/collections-dress-bg.02a3a2a.jpg";